import { FeedbackFormActionType, Action } from "../Actions/FeedbackFormActions";
import { SubmitFeatureRequest, SubmitBugReport, SubmitResourceRequest } from "..";

export interface FeedbackFormState {
  featureRequest: SubmitFeatureRequest;
  bugReport: SubmitBugReport;
  resourceRequest: SubmitResourceRequest;
}

const initalFeatureRequest: SubmitFeatureRequest = {
  title: "",
  description: "",
  featureRequirements: "",
  tagIds: [],
  isPrivate: true,
  estimatedHours: undefined
};

const initalBugReport: SubmitBugReport = {
  title: "",
  reproductionSteps: "",
  description: "",
  expectedBehaviour: "",
  link: "",
  tagId: undefined,
  isPrivate: true,
  estimatedHours: undefined
};

const iniatalResourceRequest: SubmitResourceRequest = {
  title: "",
  description: "",
  categoryName: "",
  specSheetLink: "",
  tagIds: [],
  isPrivate: true
};

const initialFeedbackFormState: FeedbackFormState = {
  featureRequest: initalFeatureRequest,
  bugReport: initalBugReport,
  resourceRequest: iniatalResourceRequest
};

const updateObject = (oldObject: any, newValues: any) => ({ ...oldObject, ...newValues });

const feedbackFormReducer = (
  state: FeedbackFormState = initialFeedbackFormState,
  action: Action<any>
) => {
  switch (action.type) {
    case FeedbackFormActionType.UPDATE_FEATURE_REQUEST: {
      return updateObject(state, { featureRequest: action.payload });
    }
    case FeedbackFormActionType.UPDATE_BUG_REPORT: {
      return updateObject(state, { bugReport: action.payload });
    }
    case FeedbackFormActionType.UPDATE_RESOURCE_REQUEST: {
      return updateObject(state, { resourceRequest: action.payload });
    }
    default:
      return state;
  }
};

export default feedbackFormReducer;
